import { requests } from "../db/dbManag";
export const checkTokenFromFCH = (token) => {
  const isTest = process.env.VUE_APP_IS_BRANCH_PROD == "0";
  const bearerToken = token || localStorage.getItem("tokenAdb2c");

  if (isTest) {
    return Promise.resolve(200);
  }

  return requests.dbManagControlloTokenFCH
    .post(
      "v1/connecthub/login",
      {},
      {
        headers: {
          Authorization: "Bearer " + bearerToken,
        },
      }
    )
    .then((res) => {
      return res.status;
    })
    .catch((e) => {
      return e?.response?.status ?? 500;
    });
};
